// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2208":"82c312da","9012":"82c312da"}[chunkId] + ".chunk.css";
};